import CareLevelResultTable from './CareLevelResultTable';

export default CareLevelResultTable;
